import { CombinedState, combineReducers, Reducer } from 'redux';
import { RouterState } from 'redux-first-history/build/es6/reducer';

import { authReducer, IAuthState } from './redux/auth/auth.reducer';
import { categoryReducer, CategoryState } from './redux/category/category.reducer';
import { filterReducer, IFilterState } from './redux/filter/filter.reducer';
import { ILayoutState, layoutReducer } from './redux/layout/layout.reducet';
import { IModalsState, modalsReducer } from './redux/modals/modals.reducer';
import { IProductState, productReducer } from './redux/products/product.reducet';

export interface RootState {
	auth: IAuthState;
	category: CategoryState;
	filter: IFilterState;
	layout: ILayoutState;
	modals: IModalsState;
	product: IProductState;
	router: RouterState;
}

export const reducers = (routerReducer: Reducer<RouterState>): Reducer<CombinedState<RootState>> =>
	combineReducers<RootState>({
		router: routerReducer,
		auth: authReducer,
		layout: layoutReducer,
		category: categoryReducer,
		product: productReducer,
		modals: modalsReducer,
		filter: filterReducer,
	});
